import React from 'react';
import AdviserSearch from './AdviserSearch';
import AdvisersSearchList from './AdvisersSearchList';
import { SearchFirmProps } from './interface/advisersInterface';

import './_SearchFirm.scss';

const SearchFirm: React.FC<SearchFirmProps> = ({ searchText, handleSearchChange, handleSearchClick, data }) => {
  return (
    <div className="search-firm">
      <AdviserSearch
        searchText={searchText}
        handleSearchChange={handleSearchChange}
        handleSearchClick={handleSearchClick}
      />
      {data.length > 0 && <AdvisersSearchList data={data} />}
    </div>
  );
};

export default SearchFirm;
